import { z } from 'zod'

import { ensureRouteData } from '@/app/query-client'
import { courseHomeQueryOptions, courseListQueryOptions } from '@/features/courses/api/queries'
import type { RouterContext } from '@/routes/layouts/root'

/**
 * `level` — the catalog filter, a level as the chips read it ("Beginner").
 * Absent is "All". The grid filters the one catalog list client-side (the
 * endpoint takes no filter), so the param keys no query; a level the catalog
 * does not have is read as absent by the screen.
 */
export const coursesSearchSchema = z.object({
  level: z.string().trim().min(1).optional().catch(undefined),
})
export type CoursesSearch = z.infer<typeof coursesSearchSchema>

/**
 * The `/courses` loader.
 *
 * MAIN, awaited together: the home shelves (Continue learning, Free lectures,
 * Start here, Going deeper) and the whole catalog (the results grid and the
 * level chips). Neither is keyed on a search param, so the screen reads both
 * with suspense and a filter or search never refetches anything.
 */
export async function loadCourses({
  context: { queryClient },
}: {
  context: RouterContext
}): Promise<void> {
  await Promise.all([
    ensureRouteData(queryClient, courseHomeQueryOptions()),
    ensureRouteData(queryClient, courseListQueryOptions()),
  ])
}
